<template>
  <v-tooltip top color="transparent" content-class="help-bubble" nudge-left="100%">
    <template v-slot:activator="{ on }">
      <v-btn
        @click="$emit('click')"
        color="primary"
        :fab="!$vuetify.breakpoint.mdAndUp"
        :small="!$vuetify.breakpoint.mdAndUp"
        :disabled="!publishing && receiving"
        tile
        v-on="on"
        class="mr-2"
      >
        <v-icon v-if="!publishing">mdi-microphone-variant</v-icon>
        <v-icon v-if="publishing">mdi-microphone-variant-off</v-icon>
        <span v-show="$vuetify.breakpoint.mdAndUp">{{
          publishing
            ? $t("participant.live.toolbar.teamCaptainStreamStop")
            : $t("participant.live.toolbar.teamCaptainStream")
        }}</span>
      </v-btn>
    </template>
    <v-card width="350px">
      <v-card-title>{{ $t("participant.live.teamCaptainStream.help.title") }}</v-card-title>
      <v-card-text class="text-justify">{{ $t("participant.live.teamCaptainStream.help.text") }}</v-card-text>
    </v-card>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    publishing: Boolean,
    receiving: Boolean,
  },
};
</script>

<style scoped></style>
